import React from 'react';
import ListingHistoryItem from './ListingHistoryItem';
import { SimpleListingObject } from '@th/shared/src/types/SimpleListing';

type Props = {
  historicalListingObjects: Array<SimpleListingObject>;
  listingId: string;
};

export default function ListingHistory({
  historicalListingObjects,
  listingId,
}: Props) {
  if (historicalListingObjects.length === 0) {
    return null;
  }

  const isMultipleListingsInHistory = historicalListingObjects.length > 1;

  return (
    <div className="flex flex-col">
      <h3 className="mb-4">Listing History</h3>
      {historicalListingObjects.map(simpleListingObject => {
        const isCurrentlySelected = simpleListingObject.id === listingId;
        const isClickable = !isCurrentlySelected && isMultipleListingsInHistory;

        return (
          <ListingHistoryItem
            simpleListingObject={simpleListingObject}
            isClickable={isClickable}
            key={simpleListingObject.id}
          />
        );
      })}
    </div>
  );
}
